import React, { useEffect, useState } from 'react';

const IconsDemo = (props) => {
   
    useEffect(() => {

        
        
        
    }, []);

    return (
        <div className="grid">
            <div className="col-12 md:col-16">
                <div className='card'>
                    <h5 style={{marginLeft:460}}>Online İşlemler</h5>
                    <div className='flex flex-row' style={{marginTop:100,marginBottom:100}}>
                        <a href="https://www.atakent2.org.tr/borcsorgulama/" target="_blank" rel="noreferrer">
                            <button style={{color:'white',marginLeft:130,height:50,width:200,background:'#038063',borderRadius:12,cursor:'pointer'}} >Aidat Borç Sorgulama ve Ödeme</button>
                        </a>
                        <a href="https://www.atakent2.org.tr/adayonetici/" target="_blank" rel="noreferrer">
                            <button style={{color:'white',marginLeft:100,height:50,width:200,background:'#4696d5',borderRadius:12,cursor:'pointer'}}>Ada Yönetici Girişi</button>
                        </a>
                        
                        <a href="http://46.221.16.212:4020/" target="_blank" rel="noreferrer">
                            <button style={{color:'white',marginLeft:100,height:50,width:200,background:'#4696d5',borderRadius:12,cursor:'pointer'}}>Site Yönetici Girişi</button>
                        </a>
                        
                    </div>
                </div>
                
                        
            </div>
        </div>
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(IconsDemo, comparisonFn);